import { useAuth0 } from "@auth0/auth0-react";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import React, { useContext } from "react";
import { createContactUsEmail } from "../../taskpane";
import { OrganisationContext, OrganisationSignalRContext } from "../../context/OrganisationContext";
import { useAppInsights } from "../../services/appInsights";
import { TelemetryEvents } from "../../telemetry/eventNames";
import { TelemetryProp, toTelemetryProps } from "../../telemetry/telemetryProps";
import { TelemetrySurface } from "../../telemetry/surfaces";
import { ChasableSignalRContext } from "../../context/ChasablesContext";

const DeactivatedOrganisation = () => {
  const { trackEvent } = useAppInsights();
  const { logout, user } = useAuth0();
  const { organisation } = useContext(OrganisationContext);

  React.useEffect(() => {
    trackEvent({
      name: TelemetryEvents.userLoggedInDeactivatedOrganisation,
      properties: toTelemetryProps({
        [TelemetryProp.surface]: TelemetrySurface.organisation,
        [TelemetryProp.organisationId]: organisation?.id,
      }),
    });
  }, [organisation?.id, trackEvent]);

  const handleContactUs = async () => {
    if (!organisation?.name || !user?.name) return;

    await createContactUsEmail(organisation.name, user.name);
  };

  const handleSignout = async () => {
    try {
      await Promise.all([ChasableSignalRContext.connection?.stop(), OrganisationSignalRContext.connection?.stop()]);
      await logout({ logoutParams: { returnTo: `${window.location.origin}/taskpane.html` } });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Container>
      <Stack justifyContent="center" alignItems="center" height="100%">
        <Typography component="h1" variant="subtitle1">
          Welcome to Attelas!
        </Typography>
        <Typography>We are sorry but you do not seem to have an active subscription to our service.</Typography>
        <Typography>Please contact us by clicking the button bellow</Typography>

        <Button variant="contained" color="primary" onClick={handleContactUs} sx={{ mt: 2 }} fullWidth>
          Contact us
        </Button>
        <Button variant="text" onClick={handleSignout} color="primary" sx={{ mt: 2 }}>
          Sign out
        </Button>
      </Stack>
    </Container>
  );
};

export default DeactivatedOrganisation;
